<template>
  <div class="">
    <div class="label-standard">Building type</div>

    <div class="mt-2">
      <select
        :value="value != null ? value : -1"
        :disabled="disabled"
        v-on:change="updateValue({
          objectType: objectType,
          key       : propertyKey, 
          value     : $event.target.value,
          index     : index
        })"
        class="select-standard">
        <option :value="null"></option>
        <option value="apartment">Apartment</option>
        <option value="flat">Flat</option>
        <option value="house">House</option>
        <option value="unit">Unit</option>
        <option value="duplex">Duplex</option>
        <option value="townhouse">Townhouse</option>
        <option value="lot">Lot</option>
        <option value="level">Level</option>
        
        <option :value="null" disabled="true">----------</option>

				<option value="antenna">Antenna</option>
				<option value="automated teller machine">Automated Teller Machine</option>
				<option value="barbecue">Barbecue</option>
				<option value="boatshed">Boatshed</option>
				<option value="building">Building</option>
				<option value="bungalow">Bungalow</option>
				<option value="cage">Cage</option>
				<option value="carpark">Carpark</option>
				<option value="carspace">Carspace</option>
				<option value="club">Club</option>
				<option value="coolroom">Coolroom</option>
				<option value="cottage">Cottage</option>
				
				<option value="factory">Factory</option>
				
				<option value="garage">Garage</option>
				<option value="hall">Hall</option>
				
				<option value="kiosk">Kiosk</option>
				<option value="lease">Lease</option>
				
				<option value="lobby">Lobby</option>
				<option value="loft">Loft</option>
				
				<option value="maisonette">Maisonette</option>
				<option value="marine berth">Marine Berth</option>
				<option value="office">Office</option>
				<option value="reserve">Reserve</option>
				<option value="room">Room</option>
				<option value="shed">Shed</option>
				<option value="shop">Shop</option>
				<option value="showroom">Showroom</option>
				<option value="sign">Sign</option>
				<option value="site">Site</option>
				<option value="stall">Stall</option>
				<option value="store">Store</option>
				<option value="strata unit">Strata unit</option>
				<option value="studio/studio apartment">Studio/studio apartment</option>
				<option value="substation">Substation</option>
				<option value="suite">Suite</option>
				<option value="tenancy">Tenancy</option>
				<option value="tower">Tower</option>
				
				
				<option value="vault">Vault</option>
				<option value="villa">Villa</option>
				<option value="ward">Ward</option>
				<option value="warehouse">Warehouse</option>
				<option value="workshop">Workshop</option>
      </select>
    </div>
  </div>
</template>

<script>
  export default {
    props : {

      objectType : {
        type    : String,
        required: false
      },

      value : {
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      disabled : {
        type : Boolean,
        required : false,
        default : false
      }
    },
  }
</script>